// @flow weak

import * as CliApp from 'app/entities/CliApp';
import { selectAppEntity } from 'app/developer-v3/store/shared/selectors';

export const selectInviteUrl = state => {
  const app = selectAppEntity(state);
  return CliApp.selectors.inviteUrl(app);
};
